/**
 * Meta Pixel (Facebook) — ID de la cuenta del anunciante.
 */
export const PIXEL_ID = '1758826665375612'

type PixelArgs = [string, ...unknown[]]

interface FbqFunction {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue: PixelArgs[]
  push: FbqFunction
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

/**
 * Carga el script oficial de fbevents.js una sola vez y deja la cola `fbq`
 * lista, replicando el snippet de Meta. Es idempotente: si el pixel ya existe
 * (por ejemplo tras un hot reload) no vuelve a inyectar nada.
 */
export function loadMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue.push(args as PixelArgs)
    }
  } as FbqFunction

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

/**
 * Inicializa el pixel y registra la visita UNA sola vez por carga de página.
 *
 * El guardia evita el PageView duplicado que aparecía al remontar la app
 * (hot reload, doble render del editor o React StrictMode).
 */
let isInitialised = false

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || isInitialised) return
  isInitialised = true

  loadMetaPixel()
  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Envía un evento estándar de Meta con sus parámetros opcionales. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
